<template>
  <!-- 招聘活动详情页 -->
  <div class="lectureDetail">
    <!-- <van-nav-bar
      :title="'活动详情'"
      :fixed="true"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar> -->
    <div class="content">
      <div class="top_box">
        <div class="tao">
          <div class="left">
            <img src="@/assets/img/home_hd_01.png"
                 alt="" />
          </div>
          <div class="right">
            <div class="qdname">{{ param.actitle }}</div>
            <van-button round
                        type="info"
                        size="mini">{{
              param.actype
            }}</van-button>
          </div>
        </div>
        <div class="info">
          <div class="infobox">
            <div class="left">
              <img src="@/assets/img/ico_hd_01.png"
                   alt="" />
            </div>
            <div class="right">
              <p>开始时间：{{ param.bd }}</p>
              <p>结束时间：{{ param.ed }}</p>
            </div>
          </div>
          <div class="infobox">
            <div class="left">
              <img src="@/assets/img/ico_hd_02.png"
                   alt="" />
            </div>
            <div class="right">
              <p>{{ param.acaddr }}</p>
            </div>
          </div>
          <div class="infobox">
            <div class="left">
              <img src="@/assets/img/ico_hd_03.png"
                   alt="" />
            </div>
            <div class="right">
              <p>联系人：{{ param.contacts }}</p>
              <p>联系电话：{{ param.contactnumber }}</p>
            </div>
          </div>
          <div class="remark">
            <div class="title">
              <div class="ico"></div>
              备注
            </div>
            <div class="cont">
              {{ param.remark }}
            </div>
          </div>
        </div>
        <van-button v-if="show_td_btn"
                    type="info"
                    @click="gotoPage()">我要投递</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getScanEntryHomeSet } from '@/request/api.js'
export default {
  data () {
    let title = this.$route.query.title || ''
    let param = localStorage.getItem('lectureDetail')
      ? JSON.parse(localStorage.getItem('lectureDetail'))
      : {}
    return {
      title,
      param,
      //扫码入职的校园招聘是否显示我要投递按钮
      show_td_btn: false
    }
  },
  created () {
    // 获取参数
    getScanEntryHomeSet().then(res => {
      const data = res.data[0]
      this.show_td_btn = data.home_xyzp_show_td_btn
      // 修改页面标题
      document.title = data.home_m_title
    })
  },
  methods: {
    onClickLeft () {
      this.$router.push('/lecture?title=' + this.title)
    },
    // goto去详情页
    gotoPage () {
      let item = this.param
      let autoid = localStorage.getItem('autoid')
      let attachfilepath = localStorage.getItem('attachfilepath')
      let istest = localStorage.getItem('istest')
      let tel = localStorage.getItem('phoneNum')
      if (autoid)
      {
        // 未登录跳转至登录页
        let obj = {
          module: '304',
          restype: item.qdname,
          zpacid: item.autoid,
          tel,
          istest,
          attachfilepath,
          autoid
        }
        // :(根据活动类别区分：319校园招聘、317猎头公司、322劳务排遣，其他传入304)
        if (item.actype == '校园招聘')
        {
          obj.module = '319'
        } else if (item.actype == '猎头公司')
        {
          obj.module = '317'
        } else if (item.actype == '劳务排遣')
        {
          obj.module = '322'
        }
        this.$router.push({
          path: '/seStaList',
          query: obj
        })
      } else
      {
        // 未登录跳转至登录页
        this.$router.push('/scanEntry?module=304')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.lectureDetail {
  height: 100vh;
  background-color: #e9eaec;
  overflow: hidden;
  .van-nav-bar {
    height: 92px;
    background: #bcdfff;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #333;
      }
    }
    /deep/.van-nav-bar__title {
      color: #333;
      font-size: 36px;
      font-weight: bold;
      font-family: Source Han Sans CN;
    }
  }
  .van-hairline--bottom::after {
    border: 0;
  }
  .content {
    height: 100%;
    // height: calc(100% - 92px);
    // margin-top: 92px;
    .top_box {
      background-image: url("~@/assets/img/home_hd_02.png");
      background-repeat: no-repeat;
      background-size: 100% 400px;
      height: 100%;
      .tao {
        display: flex;
        align-items: center;
        padding: 40px;
        height: 280px;
        .left {
          width: 35%;
          margin-right: 40px;
          display: flex;
          align-items: center;
          img {
            width: 100%;
          }
        }
        .right {
          flex: 1;
          height: 100%;
          // display: flex;
          // flex-direction: column;
          // height: 100%;
          // justify-content: space-evenly;
          .qdname {
            font-size: 34px;
            font-weight: bold;
            color: #303030;
          }
          .time,
          .addr {
            font-size: 28px;
            color: #909090;
          }
        }
      }
      .info {
        height: calc(100% - 460px);
        background: #ffffff;
        border-radius: 18px 18px 0px 0px;
        margin: 0 20px;
        overflow-y: scroll;
        .infobox {
          border-bottom: 1px solid #e5e5e5;
          margin: 20px;
          display: flex;
          align-items: center;
          .left {
            padding: 20px;
            img {
              height: 150px;
            }
          }
          .right {
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #3f3f3f;
            line-height: 45px;
          }
        }
        .remark {
          padding: 20px;
          .title {
            font-size: 45px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #232323;
            line-height: 120px;
            height: 120px;
            .ico {
              width: 6px;
              height: 40px;
              background: #0a4ce5;
              border-radius: 2px;
              display: inline-block;
            }
          }
          .cont {
            font-size: 30px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #3f3f3f;
          }
        }
      }
      .van-button {
        width: 100%;
      }
    }
  }
}
</style>
